var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _g3, _path, _path2, _path3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoPaperless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 77,
    viewBox: "0 0 80 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58.6015,
    height: 13.9559,
    rx: 6.97795,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.8691 53.3057)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.6812,
    height: 13.9559,
    rx: 6.97795,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 48.5879 72.5869)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36.6812,
    height: 13.9559,
    rx: 6.97795,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9.86914 35.8057)",
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 71.134,
    height: 13.9559,
    rx: 6.97795,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 25.8691 76.1675)",
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 76.8979,
    height: 13.9559,
    rx: 6.97795,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 16.8691 66.2432)",
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33,
    width: 28,
    height: 26,
    rx: 3,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2816_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4707 30.4609V56.6055C23.4707 57.8457 24.6504 58.8555 26.1016 58.8555H47.8477C49.2988 58.8555 50.4785 57.8457 50.4785 56.6055V24.3223C50.4785 23.0801 49.2988 22.0703 47.8477 22.0703H32.1074L23.4707 30.4609ZM47.8477 59.8496H26.1016C25.1445 59.8496 24.2441 59.5195 23.5625 58.9199C22.8613 58.3066 22.4766 57.4824 22.4766 56.6055V30.25C22.4766 30.1152 22.5313 29.9883 22.627 29.8945L31.5586 21.2168C31.6523 21.127 31.7754 21.0762 31.9063 21.0762H47.8477C48.8047 21.0762 49.707 21.4062 50.3887 22.0059C51.0879 22.6191 51.4727 23.4434 51.4727 24.3223V56.6055C51.4727 57.4844 51.0879 58.3066 50.3887 58.9219C49.707 59.5195 48.8047 59.8496 47.8477 59.8496Z",
    fill: "#55575E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2816_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3594 56.1309C53.2266 56.1309 53.0957 56.0781 52.998 55.9746C52.8086 55.7754 52.8164 55.4609 53.0156 55.2715C53.4531 54.8574 53.6934 54.3242 53.6934 53.7676V21.4824C53.6934 20.2422 52.5137 19.2324 51.0625 19.2324H35.1191C34.8457 19.2324 34.623 19.0098 34.623 18.7363C34.623 18.4609 34.8457 18.2383 35.1191 18.2383H51.0625C52.0176 18.2383 52.9199 18.5684 53.6016 19.168C54.3027 19.7813 54.6875 20.6035 54.6875 21.4824V53.7676C54.6875 54.5996 54.3379 55.3906 53.7012 55.9941C53.6035 56.084 53.4824 56.1309 53.3594 56.1309Z",
    fill: "#55575E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2816_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1987 29.7537H28.7769C30.228 29.7537 31.4077 28.7439 31.4077 27.5037V22.7498L24.1987 29.7537ZM28.7769 30.7478H22.9741C22.771 30.7478 22.5894 30.6248 22.5132 30.4373C22.437 30.2498 22.4819 30.0349 22.6265 29.8943L31.5581 21.2166C31.7027 21.0779 31.9136 21.0388 32.0991 21.115C32.2827 21.1931 32.4019 21.3748 32.4019 21.574V27.5037C32.4019 28.3826 32.0171 29.2049 31.3159 29.8181C30.6362 30.4177 29.7319 30.7478 28.7769 30.7478Z",
    fill: "#55575E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2539 36.4453H27.498C27.2227 36.4453 27 36.2227 27 35.9473C27 35.6719 27.2227 35.4492 27.498 35.4492H39.2539C39.5273 35.4492 39.752 35.6719 39.752 35.9473C39.752 36.2227 39.5273 36.4453 39.2539 36.4453Z",
    fill: "#55575E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0137 41.4004H27.498C27.2227 41.4004 27 41.1777 27 40.9043C27 40.6289 27.2227 40.4062 27.498 40.4062H47.0137C47.2891 40.4062 47.5117 40.6289 47.5117 40.9043C47.5117 41.1777 47.2891 41.4004 47.0137 41.4004Z",
    fill: "#5C70A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0137 46.3574H27.498C27.2227 46.3574 27 46.1348 27 45.8594C27 45.5859 27.2227 45.3633 27.498 45.3633H47.0137C47.2891 45.3633 47.5117 45.5859 47.5117 45.8594C47.5117 46.1348 47.2891 46.3574 47.0137 46.3574Z",
    fill: "#55575E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0137 51.3125H27.498C27.2227 51.3125 27 51.0918 27 50.8164C27 50.541 27.2227 50.3184 27.498 50.3184H47.0137C47.2891 50.3184 47.5117 50.541 47.5117 50.8164C47.5117 51.0918 47.2891 51.3125 47.0137 51.3125Z",
    fill: "#5C70A1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2816_52178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5 39C56.9834 39 58.4334 39.4399 59.6668 40.264C60.9001 41.0881 61.8614 42.2594 62.4291 43.6299C62.9968 45.0003 63.1453 46.5083 62.8559 47.9632C62.5665 49.418 61.8522 50.7544 60.8033 51.8033C59.7544 52.8522 58.418 53.5665 56.9632 53.8559C55.5083 54.1453 54.0003 53.9967 52.6299 53.4291C51.2594 52.8614 50.0881 51.9001 49.264 50.6668C48.4399 49.4334 48 47.9834 48 46.5C48 44.5109 48.7902 42.6032 50.1967 41.1967C51.6032 39.7902 53.5109 39 55.5 39ZM55.5 37C53.6211 37 51.7844 37.5572 50.2221 38.601C48.6598 39.6449 47.4422 41.1286 46.7231 42.8645C46.0041 44.6004 45.816 46.5105 46.1825 48.3534C46.5491 50.1962 47.4539 51.8889 48.7825 53.2175C50.1111 54.5461 51.8038 55.4509 53.6466 55.8175C55.4895 56.184 57.3996 55.9959 59.1355 55.2769C60.8714 54.5578 62.3551 53.3402 63.399 51.7779C64.4428 50.2156 65 48.3789 65 46.5C65 43.9804 63.9991 41.5641 62.2175 39.7825C60.4359 38.0009 58.0196 37 55.5 37Z",
    fill: "#212935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 38C53.8189 38 52.1755 38.4985 50.7777 39.4325C49.3798 40.3665 48.2904 41.694 47.647 43.2472C47.0037 44.8004 46.8354 46.5094 47.1633 48.1583C47.4913 49.8071 48.3008 51.3217 49.4896 52.5104C50.6783 53.6992 52.1929 54.5087 53.8417 54.8367C55.4906 55.1646 57.1996 54.9963 58.7528 54.353C60.306 53.7096 61.6335 52.6202 62.5675 51.2223C63.5015 49.8245 64 48.1811 64 46.5C64 44.2457 63.1045 42.0837 61.5104 40.4896C59.9163 38.8955 57.7543 38 55.5 38Z",
    fill: "#3C548E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9141 46.5001L58.7091 44.7051C58.8968 44.5175 59.0022 44.263 59.0022 43.9976C59.0022 43.7323 58.8968 43.4778 58.7091 43.2901C58.5215 43.1025 58.267 42.9971 58.0016 42.9971C57.7363 42.9971 57.4818 43.1025 57.2941 43.2901L55.4991 45.0851L53.7041 43.2901C53.5165 43.1025 53.262 42.9971 52.9966 42.9971C52.7313 42.9971 52.4768 43.1025 52.2892 43.2901C52.1015 43.4778 51.9961 43.7323 51.9961 43.9976C51.9961 44.263 52.1015 44.5175 52.2892 44.7051L54.0841 46.5001L52.2892 48.2951C52.1962 48.388 52.1225 48.4983 52.0723 48.6197C52.022 48.7411 51.9961 48.8712 51.9961 49.0026C51.9961 49.134 52.022 49.2641 52.0723 49.3855C52.1225 49.5069 52.1962 49.6172 52.2892 49.7101C52.3821 49.803 52.4924 49.8767 52.6138 49.927C52.7351 49.9773 52.8653 50.0032 52.9966 50.0032C53.128 50.0032 53.2582 49.9773 53.3795 49.927C53.5009 49.8767 53.6112 49.803 53.7041 49.7101L55.4991 47.9151L57.2941 49.7101C57.4818 49.8978 57.7363 50.0032 58.0016 50.0032C58.267 50.0032 58.5215 49.8978 58.7091 49.7101C58.8968 49.5225 59.0022 49.268 59.0022 49.0026C59.0022 48.7373 58.8968 48.4828 58.7091 48.2951L56.9141 46.5001Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 60H63",
    stroke: "#55575E",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60H67",
    stroke: "#55575E",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 60H12",
    stroke: "#55575E",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57.5H56",
    stroke: "#91929D",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57.5H60",
    stroke: "#91929D",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57.5H18",
    stroke: "#91929D",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 69.6465L16.7677 71.0607",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 71.0605L16.7677 69.6463",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35352 30.6465L4.76773 32.0607",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35352 32.0605L4.76773 30.6463",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3535 60.6465L78.7677 62.0607",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3535 62.0605L78.7677 60.6463",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3535 8.64648L57.7677 10.0607",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3535 10.0605L57.7677 8.64633",
    stroke: "#5C70A1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 51,
    r: 1,
    fill: "white",
    stroke: "#5C70A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 31,
    r: 1,
    fill: "white",
    stroke: "#5C70A1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 1,
    fill: "white",
    stroke: "#5C70A1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 72,
    r: 1,
    fill: "white",
    stroke: "#5C70A1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2816_52178",
    x: 22.4766,
    y: 21.0762,
    width: 30.9961,
    height: 40.7734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_52178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_52178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2816_52178",
    x: 34.623,
    y: 18.2383,
    width: 22.0645,
    height: 39.8926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_52178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_52178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2816_52178",
    x: 22.4766,
    y: 21.0767,
    width: 11.9258,
    height: 11.6714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_52178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_52178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2816_52178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(46 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoPaperless);
export default __webpack_public_path__ + "static/media/goPaperless.c422b72fb676f747e48281675cfb77cc.svg";
export { ForwardRef as ReactComponent };